import React from "react";

/* Brand logo — globe icon (official brand PNG) + wordmark text.
   The icon lives at /public/brand/gosmartnest-icon.png; text is inline. */
export const Logo = ({ compact = false, className = "", height = 44 }) => {
    const iconSize = height;
    return (
        <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
            <img
                src="/brand/gosmartnest-icon.png"
                alt="GoSmartNest"
                style={{ height: iconSize, width: iconSize }}
                className="object-contain"
                draggable={false}
            />
            {!compact && (
                <div className="leading-none">
                    <div className="text-[18px] sm:text-[20px] font-bold tracking-tight">
                        <span className="text-[#1B2E7A]">Go</span>
                        <span className="text-[#1BB6F0]">Smart</span>
                        <span className="text-[#1B2E7A]">Nest</span>
                    </div>
                    <div className="text-[10px] tracking-[0.28em] text-[#1B2E7A]/70 mt-1 font-semibold">AUTOMATION</div>
                </div>
            )}
        </div>
    );
};
